<template>
  <div class="statistics-top-cla">
    <div class="statistics-left-cla">
      <div class="statistics-height-cla">
        <img
          class="statistics-icon-cla"
          src="../../../assets/new/statistics/total.svg"
        />
        <span class="chart-title">{{ $t('statistics.todayCallsTotal') }}</span>
      </div>
      <zkLoading
        v-if="totalLoad"
        :width="20"
        :height="40"
        :margin="2"
      ></zkLoading>
      <div @click.stop="toDetails()" v-if="!totalLoad" class="total-count-cla">
        {{ totalCount }}
      </div>
    </div>
    <div class="statistics-right-cla">
      <div class="statistics-height-cla">
        <img
          class="statistics-icon-cla"
          src="../../../assets/new/statistics/sort.svg"
        />
        <span class="chart-title">{{ $t('statistics.todayCallsSort') }}</span>
      </div>
      <zkLoading
        v-if="statisticsLoad"
        :width="20"
        :height="40"
        :margin="2"
      ></zkLoading>
      <div v-if="!statisticsLoad" class="sort-info-cla">
        <div
          class="sort-item-cla"
          :key="item.apiName"
          v-for="(item, index) of paihang"
        >
          <div class="item-name-cla">
            <img
              v-if="index === 0"
              class="sort-icon-cla"
              src="../../../assets/new/statistics/sort1.svg"
            />
            <img
              v-if="index === 1"
              class="sort-icon-cla"
              src="../../../assets/new/statistics/sort2.svg"
            />
            <img
              class="sort-icon-cla"
              v-if="index === 2"
              src="../../../assets/new/statistics/sort3.svg"
            />
            {{ item.apiName }}
          </div>
          <div @click.stop="toDetails(item)" class="item-count-cla">
            {{ item.num }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentDateRange } from '@/utils/utils.js'
import { getStatisticTotal, getStatistic } from '@/services/statisticsApi.js'
export default {
  data() {
    return {
      params: {
        startTime: 0,
        endTime: 1605249786836,
        appCode: 'DBS'
      },
      totalCount: 0,
      paihang: [],
      interval: null,
      totalLoad: true,
      statisticsLoad: true
    }
  },
  mounted() {
    this.params.startTime = getCurrentDateRange()[0]
    this.params.endTime = getCurrentDateRange()[1]
    this.getStatisticTotal()
    this.getStatistic()
    this.interval = setInterval(() => {
      this.getStatisticTotal()
      this.getStatistic()
    }, 10000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    toDetails(item) {
      this.$router.push({
        name: 'statisticsCallDetails',
        params: {
          type: 'currentDate',
          apiName: item ? item.apiName : ''
        }
      })
    },
    getStatisticTotal() {
      getStatisticTotal(this.params)
        .then(data => {
          if (data.code === '00000000') {
            this.totalCount = data.payload.data
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {
          this.$message.error(e)
        })
        .finally(() => {
          this.totalLoad = false
        })
    },

    // 获取接口排行
    getStatistic() {
      let params = Object.assign({}, this.params)
      params.topCount = 5
      getStatistic(params)
        .then(data => {
          if (data.code === '00000000') {
            this.paihang = data.payload.data
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(e => {
          this.$message.error(e)
        })
        .finally(() => {
          this.statisticsLoad = false
        })
    }
  }
}
</script>

<style scoped lang="less">
.statistics-top-cla {
  display: flex;
  .statistics-left-cla {
    background-color: #fff;
    width: 280px;
    height: 150px;
    border-radius: 2px;
    .total-count-cla {
      text-align: center;
      color: #5b8ef5;
      font-size: 40px;
      font-weight: 600;
      cursor: pointer;
    }
  }
  .statistics-icon-cla {
    width: 20px;
    height: 20px;
    margin-right: 16px;
  }
  .statistics-height-cla {
    height: 70px;
    line-height: 70px;
    display: flex;
    align-items: center;
    padding-left: 16px;
  }

  .statistics-right-cla {
    margin-left: 12px;
    background-color: #fff;
    height: 140px;
    border-radius: 2px;
    flex-grow: 1;
    padding-bottom: 10px;
    .sort-info-cla {
      display: flex;
      justify-content: space-around;
    }
    .sort-item-cla {
      border-right: 1px solid rgba(0, 0, 0, 0.2);
      text-align: center;
      flex-grow: 1;
      .sort-icon-cla {
        width: 16px;
        height: 16px;
        position: relative;
        top: 2px;
      }
      .item-name-cla {
        font-size: 16px;
        font-weight: 500;
      }
      .item-count-cla {
        font-size: 24px;
        font-weight: 500;
        color: #32b84c;
        cursor: pointer;
      }
    }
    .sort-item-cla:last-child {
      border-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/statistics/apiStatistics/statisticsTop.vue